import React, { useRef, ChangeEvent, useEffect, useState, useMemo } from 'react';
import type { StationComponent } from "../../../../api/map-stations"
import { findCityStationNum, findNearByStationNum } from "../../../../api/map-stations"
import 'react-photo-view/dist/react-photo-view.css';
import './index.less';
import { flatten, getChannel, reportUserBehavior, throttle } from '../../../../utils/common';
import { trackGdp } from '../../../../utils/gio-report';

interface Item extends StationComponent {
  checked?: boolean;
  type?: number;
  nums?: number;
}
interface StationItemProps {
  toExpand: () => void;
  setSelectStationType: (val?: StationComponent) => any;
  expandFlag: boolean;
  selectStationType?: StationComponent;
  stationTypeList: StationComponent[];
  initConfig: {
    type: number;
    lat: number | string;
    lng: number | string;
    radius: number
  };
  cityConfig: {
    cityCode: string;
    cityName: string;
  };
  configCode?: string;
  location?: any
}

export default (props: StationItemProps) => {
  const {
    expandFlag,
    toExpand,
    setSelectStationType,
    selectStationType,
    stationTypeList,
    initConfig,
    cityConfig,
    location,
    configCode
  } = props
  const [selectCode, setSelectCode] = useState<string | undefined>(selectStationType?.code)
  const [stationList, setStationList] = useState<Item[]>([])
  const [firstStationList, setFirstStationList] = useState<Item[]>([])

  const changeStationType = (item: Item) => {
    // 上报埋点
    trackGdp('P11247', 'B004', {
      station_type: item?.code || '',
      config_code: configCode,
      fallBack_code: item?.fallBackCode || ''
    })
    if (selectCode === item.code) {
      setSelectStationType(undefined)
      setSelectCode(undefined)
    } else {
      setSelectStationType(item)
      setSelectCode(item.code)
    }
  }

  const getRealStationList = (aggregateList, citycode) => {

    findCityStationNum({ source: 1, cityCode: citycode, aggregateList: aggregateList }).then(({ data }) => {
      let obj = {}
      aggregateList.map(i1 => {
        data.result.map(i2 => {
          if (i1.aggId === i2.aggId) {
            obj[i1.aggId] = i2.nums
          }
        })
      })
      let list2: any[] = []
      Object.keys(obj).map(key => {
        list2 = stationTypeList.map((i: any) => {
          if (i.code === key) {
            i.nums = obj[key]
          } else if (i.fallBackCode === key) {
            i.fallBackNums = obj[key]
          }
          return i
        })
      })
      // 第一次初始化后只更新数量
      let list3 = !stationList.length
        ? list2.map(i => {
          // 根据是否常显等条件判断展示类型&数量等数据
          const isAllZero = i.nums === 0 && i.fallBackNums === 0
          const itemShouldShowName = i.alwaysShow ? i.name : ((i.nums > 0 || isAllZero) ? i.name : i.fallBackName)
          const itemShouldShowCode = i.alwaysShow ? i.code : ((i.nums > 0 || isAllZero) ? i.code : i.fallBackCode)
          const itemShouldShowNums = i.alwaysShow ? i.nums : ((i.nums > 0 || isAllZero) ? i.nums : i.fallBackNums)
          const itemShouldShowCodeList = i.alwaysShow ? i.filterCodeList : ((i.nums > 0 || isAllZero) ? i.filterCodeList : i.fallBackFilterCodeList)
          return {
            ...i,
            name: itemShouldShowName,
            code: itemShouldShowCode,
            filterCodeList: itemShouldShowCodeList,
            nums: itemShouldShowNums
          }
        })
        : stationList.map(i => {
          let newItem = { ...i }
          list2.forEach(i1 => {
            if (i.code === i1.code) {
              newItem.nums = i1.nums
            }
            if (i.code === i1.fallBackCode) {
              newItem.nums = i1.fallBackNums
            }
          })
          return newItem
        })
      // 上报埋点
      trackGdp('P11247', 'B003', {
        station_type: list3.map(i => i.code).join(',') || '',
        config_code: configCode,
        fallback_code: list3.map(i => i.fallBackCode).join(',') || ''
      })
      setStationList(list3)
      // 当前选中的类型不在列表中，需要清空请求选中条件
      if (selectCode && list3.find(i => i.code === selectCode)?.nums === 0) {
        setSelectStationType(undefined)
        setSelectCode(undefined)
      }
      // 缓存第一次进页面初始化时的类型数据
      !firstStationList.length && setFirstStationList(list3)
    })
  }
  const getRealNearByStationList = (aggregateList, latitude, longitude, radius) => {
    findNearByStationNum({ source: 1, latitude, longitude, aggregateList, radius }).then(({ data }) => {
      let obj = {}
      aggregateList.map(i1 => {
        data.result.map(i2 => {
          if (i1.aggId === i2.aggId) {
            obj[i1.aggId] = i2.nums
          }
        })
      })
      let list2: any[] = []
      Object.keys(obj).map(key => {
        list2 = stationTypeList.map((i: any) => {
          if (i.code === key) {
            i.nums = obj[key]
          } else if (i.fallBackCode === key) {
            i.fallBackNums = obj[key]
          }
          return i
        })
      })

      // 第一次初始化后只更新数量
      let list3 = !stationList.length
        ? list2.map(i => {
          // 根据是否常显等条件判断展示类型&数量等数据
          const isAllZero = i.nums === 0 && i.fallBackNums === 0
          const itemShouldShowName = i.alwaysShow ? i.name : ((i.nums > 0 || isAllZero) ? i.name : i.fallBackName)
          const itemShouldShowCode = i.alwaysShow ? i.code : ((i.nums > 0 || isAllZero) ? i.code : i.fallBackCode)
          const itemShouldShowNums = i.alwaysShow ? i.nums : ((i.nums > 0 || isAllZero) ? i.nums : i.fallBackNums)
          const itemShouldShowCodeList = i.alwaysShow ? i.filterCodeList : ((i.nums > 0 || isAllZero) ? i.filterCodeList : i.fallBackFilterCodeList)
          return {
            ...i,
            name: itemShouldShowName,
            code: itemShouldShowCode,
            filterCodeList: itemShouldShowCodeList,
            nums: itemShouldShowNums
          }
        }) : stationList.map(i => {
          let newItem = { ...i }
          list2.forEach(i1 => {
            if (i.code === i1.code) {
              newItem.nums = i1.nums
            }
            if (i.code === i1.fallBackCode) {
              newItem.nums = i1.fallBackNums
            }
          })
          return newItem
        })
      console.log(list3, 'list3');
      setStationList(list3)
      // 上报埋点
      trackGdp('P11247', 'B003', {
        station_type: list3.map(i => i.code).join(',') || '',
        config_code: configCode,
        fallback_code: list3.map(i => i.fallBackCode).join(',') || ''
      })
      // 当前选中的类型不在列表中，需要清空请求选中条件
      if (selectCode && list3.find(i => i.code === selectCode)?.nums === 0) {
        setSelectStationType(undefined)
        setSelectCode(undefined)
      }
      // 缓存第一次进页面初始化时的类型数据
      !firstStationList.length && setFirstStationList(list3)
    })
  }

  /**
   * 获取显示文案
   */
  const getNearbyStationText = (data) => {
    if (!data) return ''
    let copywriting = '';
    switch (data.type) {
      case 0:// 附近距离
        copywriting = `附近<span style="color:#71BE1D;padding: 0 4px;">${data.radius / 1000}km</span>的充电站`;
        break;
      case 1:// 指定城市
        copywriting = `<span style="color:#71BE1D;padding: 0 4px;">${data.cityName}</span>的充电站`;
        break;
      case 2:// 所在城市
        copywriting = `<span style="color:#71BE1D;padding: 0 4px;">${data.cityName}</span>的充电站`;
        break;
      default:
        copywriting = `小鹏汽车总部附近<span style="color:#71BE1D;padding: 0 4px;">${data.radius}km</span>的充电站`;
        break;
    }
    return copywriting;
  };

  const getStationList = () => {
    const list = stationTypeList.map(i => ({ aggId: i.code, filterCodeList: i.filterCodeList, name: i.name, alwaysShow: i.alwaysShow }))
    const list2 = stationTypeList.map(i => ({ aggId: i.fallBackCode, filterCodeList: i.fallBackFilterCodeList, name: i.fallBackName, alwaysShow: i.alwaysShow }))
    const list3 = [...list, ...list2].filter(i => i.aggId)

    // 附近站点
    if (initConfig.type === 0 && location?.lat && location?.lng && initConfig?.radius) {
      getRealNearByStationList(list3, location.lat, location.lng, initConfig.radius)
    }
    // 所在城市 | 指定城市
    else if ([1, 2].includes(initConfig.type) && cityConfig.cityCode) {
      console.log('所在城市 | 指定城市');
      getRealStationList(list3, cityConfig.cityCode)
    }
    // 黑色坐标经纬度变化时，需要清空当前选中的类型
    // setSelectStationType(undefined)
    // setSelectCode(undefined)
  }

  useEffect(() => {
    if (stationTypeList?.length > 0) {
      console.log('站点类型数据变化出触发重查', stationTypeList);
      initConfig?.type !== undefined && initConfig?.type === 0 && getStationList()
    }
  }, [stationTypeList, initConfig, location])

  useEffect(() => {
    if (stationTypeList?.length > 0) {
      console.log('城市数据变化出触发重查', stationTypeList);
      initConfig?.type !== undefined && [1, 2].includes(initConfig?.type) && getStationList()
    }
  }, [initConfig, cityConfig])

  return (
    <div className='stationTypeWrap' style={{
      bottom: (expandFlag || !selectCode) ? '-0.48rem' : '-1.2rem'
    }}>
      {firstStationList.some(i => i.nums !== 0) && <div className='copywriting' dangerouslySetInnerHTML={{ __html: getNearbyStationText({ ...initConfig, ...cityConfig }) }}></div>}
      {(firstStationList.some(i => i.nums !== 0)) ?
        <>
          <div className='stationTypeCard'>
            {stationList.map((i, index) => (
              <div className={`cardItem ${i?.nums ? "" : 'cardItem-disabled'}`} key={index} onClick={() => { !!i?.nums && changeStationType(i) }}>
                <div className={`num ${i.code === selectCode ? 'checked' : ''}`}>{i?.nums}</div>
                <div className={`stationType ${i.code === selectCode ? 'checked' : ''}`}>{i.name}</div>
                {!!i?.nums &&
                  ((i.code === selectCode) ?
                    (<div className="checkedIcon"></div>)
                    : (<div className="uncheckIcon"></div>))
                }
              </div>
            ))}
          </div>
          {
            stationList.find(i => i.code === selectCode)?.nums !== 0 &&
            <div className="open" onClick={toExpand} style={{ display: (expandFlag || !selectCode) ? 'none' : '' }}>
              <div>展开</div>
              <div className="openIcon"></div>
            </div>
          }
        </>
        : (
          <div className='emptyStations'>
            <div className='line'>高效·智能·品质·安全</div>
            <div className='line'>全国小鹏自营充电网络上线 <span className='highlight'>1000+</span>座</div>
            <div className='line'>适用车主免费权益充电站<span className='highlight'>2200+</span>座</div>
          </div>
        )
      }
    </div>
  );
};
